import { isUndefined } from './logic';
export const intersperse = (delim, array) => {
    const newArray = array.slice(0, 1);
    for (let i = 1; i < array.length; i++) {
        newArray.push(delim(i), array[i]);
    }
    return newArray;
};
export const cast = (subject) => {
    if (isUndefined(subject)) {
        return [];
    }
    else if (Array.isArray(subject)) {
        return subject;
    }
    else {
        return [subject];
    }
};
